import React from "react";
import OverlayContainerWithMaterialUi from "./OverlayContainerWithMaterialUi";
import { handleCancelSubscription } from "../../utils/zohoHelper";

const IndvidualCanceCurrentSubscriptionWarn = ({ open, onClose, planCode }) => {
  return (
    <div>
      <OverlayContainerWithMaterialUi open={false}>
        <div className="cancel-subscription-warn-container">
          <div className="cancel-subscription-warn-header ">
            <h2 className="text-[20px] font-[700]">
              Purchasing DigieSign Pro Plan
            </h2>
            <button onClick={onClose}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="2"
                  y="2.70703"
                  width="1"
                  height="28"
                  rx="0.5"
                  transform="rotate(-45 2 2.70703)"
                  fill="#303030"
                />
                <rect
                  x="21.7988"
                  y="2"
                  width="1"
                  height="28"
                  rx="0.5"
                  transform="rotate(45 21.7988 2)"
                  fill="#303030"
                />
              </svg>
            </button>
          </div>
          <h4 className="cancel-subscription-warn-description ">
            If you choose to proceed with this plan, your current subscription
            will be canceled to initiate the new plan.
          </h4>
          <div className="cancel-subscription-warn-actions">
            <button
              className="primaryButton "
              onClick={() => {
                handleCancelSubscription("12344");
              }}
            >
              {"Continue"}
            </button>
          </div>
        </div>
      </OverlayContainerWithMaterialUi>
    </div>
  );
};

export default IndvidualCanceCurrentSubscriptionWarn;
